// Hlidac zlevnenych upsellu v kosiku (2026-09-02, v3.3 po Codex review kolo 2 + live testu (Globe checkout)).
// Upselly jsou skryte produkty se slevou zapecenou v cene: pribaleni (yerb-chill-pribaleni k Drive,
// yerb-drive-pribaleni k Chill, tiery K 1 / Ke 2 / Ke 3 balenim), Mini "k sade" (199 misto 349),
// lahev a pohar "vyhodne" (199/199) z drawer cross-sellu (kolekce cart-upsell). Kosik je neumi svazat
// s hlavnim produktem: po jeho smazani sleva zustala (objednavka #1674, Drive za 600 misto 899).
// Invarianty, ktere hlidac vynucuje po kazde zmene kosiku a pred odeslanim do pokladny:
//  1. upsell bez kvalifikujiciho hlavniho produktu -> prepne se na bezny produkt za plnou cenu (1 ks)
//  2. tier pribaleni = skutecny pocet baleni druheho napoje v kosiku
//  3. z kazdeho upsellu nejvys jeden radek a mnozstvi 1 (dalsi radky -> bezny produkt)
// Pokladna: kosik BEZ upsellu se nezdrzuje (zadny intercept). Kosik S upsellem je fail-closed:
// kdyz se nepodari overit nebo opravit, tlacitko neodesle a zobrazi chybu.
// Neni to bezpecnostni hranice (JS vypnuty, primy /checkout, permalink) - to resi jen serverova sleva
// nebo validation function (plan B). Dynamicka tlacitka (Shop Pay) se s upsellem nerenderuji (main-cart-footer.liquid).
// Globe (vydejni mista) nahrazuje tlacitko Pokladna klonem type=button a sama naviguje na /checkout
// s predvyplnenou adresou. U kosiku s upsellem se jeji click v capture fazi zastavi, kosik se overi
// a pak se klik na klon zopakuje s priznakem, aby Globe dokoncila navigaci vcetne prefillu.
// Nacita se z cart-drawer.liquid (kazda stranka) i main-cart-items.liquid.
(function () {
  if (window.__yerbAddonGuard) return;
  window.__yerbAddonGuard = true;

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var FETCH_TIMEOUT = 8000;
  var CHECKOUT_DEADLINE = 20000;
  var MAX_ROUNDS = 3;
  var MAX_DRAIN = 4;
  var NOTE_KEY = 'yerbAddonNote';
  // needs: 'drive' / 'chill' = pocet baleni druheho napoje (tiery), 'any' = aspon jeden hlavni napoj v kosiku
  // flavorIndex: ktera option upsellu se prenese jako prichut beznemu produktu (null = bez prichuti)
  var ADDON = {
    'yerb-chill-pribaleni': { needs: 'drive', tiers: true, regular: 'yerb-chill', flavorIndex: null },
    'yerb-drive-pribaleni': { needs: 'chill', tiers: true, regular: 'yerb-drive', flavorIndex: 1 },
    'yerb-drive-10-k-sade': { needs: 'any', regular: 'yerb-drive-10', flavorIndex: 0 },
    'yerb-chill-10-k-sade': { needs: 'any', regular: 'yerb-chill-10', flavorIndex: 0 },
    'lahev-vyhodne': { needs: 'any', regular: 'lahev', flavorIndex: null },
    'pohar-vyhodne': { needs: 'any', regular: 'pohar-yerb', flavorIndex: null }
  };
  var BAGS = {
    'yerb-drive': 1, 'yerb-drive-duo': 2, 'yerb-drive-trio': 3,
    'yerb-chill': 1, 'yerb-chill-duo': 2, 'yerb-chill-trio': 3
  };
  // hlavni napoje, ktere odemykaji cross-sell z draweru (lahev, pohar, brcko, e-book neodemykaji)
  var MAIN = {
    'yerb-drive': 1, 'yerb-drive-duo': 1, 'yerb-drive-trio': 1, 'yerb-drive-10': 1,
    'yerb-chill': 1, 'yerb-chill-duo': 1, 'yerb-chill-trio': 1, 'yerb-chill-10': 1,
    'yerb-starter-den-noc': 1, 'yerb-den-noc': 1, 'yerb-discovery-duo': 1
  };
  var TIER_LABEL = { 1: 'K 1 balení', 2: 'Ke 2 balením', 3: 'Ke 3 balením' };

  var productCache = {};
  var timer = null;
  var inflight = null;
  var dirty = false;
  var checkoutRunning = false;
  var mutationPending = false; // Dawn prave meni kosik (remove / quantity), cart update event jeste neprisel
  var mutationWaiters = [];

  // ---------- sit ----------
  function fetchJSON(url, opts) {
    opts = opts || {};
    opts.credentials = 'same-origin';
    var ctrl = typeof AbortController === 'function' ? new AbortController() : null;
    if (ctrl) opts.signal = ctrl.signal;
    var t = ctrl ? setTimeout(function () { ctrl.abort(); }, FETCH_TIMEOUT) : null;
    return fetch(url, opts).then(function (r) {
      if (!r.ok) { if (t) clearTimeout(t); throw new Error(url + ' ' + r.status); }
      return r.json().then(function (j) { if (t) clearTimeout(t); return j; });
    }).catch(function (e) { if (t) clearTimeout(t); throw e; });
  }
  function getJSON(url) { return fetchJSON(url); }
  function postJSON(url, body) {
    return fetchJSON(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) });
  }
  function wait(ms) { return new Promise(function (res) { setTimeout(res, ms); }); }
  function product(handle) {
    if (!productCache[handle]) {
      productCache[handle] = getJSON(ROOT + 'products/' + handle + '.js').catch(function (e) { delete productCache[handle]; throw e; });
    }
    return productCache[handle];
  }
  // wantOpts: pole hodnot option (null = libovolna). Zadny tichy fallback: kdyz presna varianta
  // (vcetne prichuti) neni dostupna, vraci null a volajici to resi jako chybu (fail-closed v pokladne).
  function findVariant(handle, wantOpts) {
    return product(handle).then(function (p) {
      for (var i = 0; i < p.variants.length; i++) {
        var v = p.variants[i];
        if (!v.available) continue;
        var ok = wantOpts.every(function (o, idx) { return o == null || (v.options[idx] || '') === o; });
        if (ok) return v;
      }
      return null;
    });
  }

  // ---------- analyza ----------
  function analyse(cart) {
    var bags = { drive: 0, chill: 0, any: 0 };
    cart.items.forEach(function (it) {
      if (MAIN[it.handle]) bags.any += it.quantity;
      var b = BAGS[it.handle];
      if (!b) return;
      bags[it.handle.indexOf('chill') > -1 ? 'chill' : 'drive'] += b * it.quantity;
    });
    var fixes = [];
    var seen = {};
    cart.items.forEach(function (it) {
      var rule = ADDON[it.handle];
      if (!rule) return;
      var opts = it.variant_options || [];
      var flavor = rule.flavorIndex == null ? null : (opts[rule.flavorIndex] || null);
      var regular = { kind: 'regular', item: it, handle: rule.regular, opts: [flavor], qty: 1 };
      if (seen[it.handle]) { fixes.push(regular); return; } // druhy radek stejneho upsellu
      seen[it.handle] = true;
      var have = bags[rule.needs];
      if (have <= 0) { fixes.push(regular); return; }
      if (rule.tiers) {
        var tier = parseInt(String(opts[0] || '').replace(/\D/g, ''), 10) || 1;
        var want = Math.min(have, 3);
        if (want !== tier) {
          fixes.push({ kind: 'tier', item: it, handle: it.handle, opts: flavor ? [TIER_LABEL[want], flavor] : [TIER_LABEL[want]], qty: 1 });
          return;
        }
      }
      if (it.quantity !== 1) fixes.push({ kind: 'qty', item: it });
    });
    return fixes;
  }
  function hasRegularFix(fixes) {
    return fixes.some(function (f) { return f.kind === 'regular'; });
  }
  function noteFor(kind) {
    if (kind === 'regular') return 'Zvýhodněná cena platí jen k Yerbu v košíku. Přepnuto na běžnou cenu.';
    if (kind === 'tier') return 'Sleva na přibalení odpovídá počtu balení v košíku, cena upravena.';
    return 'Zvýhodněný doplněk jde jen 1 ks na objednávku.';
  }

  // ---------- opravy ----------
  // Shopify meni item.key podle slozeni kosiku (po add.js stary klic vraci 400), proto se radek hleda
  // vzdy v cerstvem /cart.js podle variant_id a meni pres 1-based `line`. Poradi: nejdriv odebrat, pak pridat,
  // aby pri vypadku sítě nezustal zlevneny radek vedle plne ceny.
  function lineOf(cart, item) {
    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].variant_id === item.variant_id && cart.items[i].handle === item.handle) return i + 1;
    }
    return 0;
  }
  function setLineQty(item, qty) {
    return getJSON(ROOT + 'cart.js').then(function (cart) {
      var line = lineOf(cart, item);
      if (!line) return null; // radek uz nekdo odstranil
      return postJSON(ROOT + 'cart/change.js', { line: line, quantity: qty });
    });
  }
  function applyOne(f) {
    if (f.kind === 'qty') return setLineQty(f.item, 1);
    return findVariant(f.handle, f.opts).then(function (v) {
      if (!v) throw new Error('addon-guard: varianta nenalezena ' + f.handle);
      return setLineQty(f.item, 0)
        .then(function () { return postJSON(ROOT + 'cart/add.js', { items: [{ id: v.id, quantity: f.qty }] }); });
    });
  }
  // Opakuje analyzu a opravy, dokud kosik nesplnuje invarianty. Vraci { ok, changed, note }.
  function validate(firstFixes) {
    var changed = false;
    var note = null;
    var round = 0;
    function step(fixes) {
      if (!fixes.length) return { ok: true, changed: changed, note: note };
      if (round++ >= MAX_ROUNDS) return { ok: false, changed: changed, note: note };
      return fixes.reduce(function (chain, f) {
        return chain.then(function () { return applyOne(f).then(function () { changed = true; note = note || noteFor(f.kind); }); });
      }, Promise.resolve())
        .then(function () { return getJSON(ROOT + 'cart.js'); })
        .then(function (cart) { return step(analyse(cart)); });
    }
    return step(firstFixes);
  }

  // Jedina serializovana fronta pro pozadi i pokladnu. grace=true: pred prepnutim na plnou cenu
  // dvakrat pockat (PDP nejdriv prida pribaleni a az potom hlavni baleni).
  // Kdyz behem behu prijde dalsi zmena kosiku (dirty), bezi se znovu, dokud neni fronta prazdna (max MAX_DRAIN).
  function ensureValid(grace) {
    if (inflight) { dirty = true; return inflight; }
    var drains = 0;
    function finish(res) {
      inflight = null;
      if (dirty && drains++ < MAX_DRAIN) { dirty = false; return ensureValid(false).then(function (r2) {
        return { ok: r2.ok, changed: res.changed || r2.changed, note: res.note || r2.note };
      }); }
      if (dirty) { dirty = false; return { ok: false, changed: res.changed, note: res.note }; }
      return res;
    }
    inflight = getJSON(ROOT + 'cart.js').then(function (cart) {
      var fixes = analyse(cart);
      if (!fixes.length) return { ok: true, changed: false, note: null };
      if (grace && hasRegularFix(fixes)) {
        return wait(1500).then(function () { return getJSON(ROOT + 'cart.js'); }).then(function (c2) {
          var f2 = analyse(c2);
          if (!f2.length) return { ok: true, changed: false, note: null };
          if (!hasRegularFix(f2)) return validate(f2);
          return wait(2500).then(function () { return getJSON(ROOT + 'cart.js'); }).then(function (c3) { return validate(analyse(c3)); });
        });
      }
      return validate(fixes);
    }).then(finish, function (e) {
      inflight = null;
      if (dirty) { dirty = false; schedule(); }
      throw e;
    });
    return inflight;
  }
  // Dawn remove/quantity: mezi klikem a cart update eventem je kosik v pohybu; pokladna musi pockat.
  function waitForMutation() {
    if (!mutationPending) return Promise.resolve();
    return new Promise(function (res) {
      var done = false;
      var t = setTimeout(function () { if (!done) { done = true; res(); } }, FETCH_TIMEOUT);
      mutationWaiters.push(function () { if (!done) { done = true; clearTimeout(t); res(); } });
    });
  }
  function mutationStarted() { mutationPending = true; }
  function mutationSettled() {
    mutationPending = false;
    var w = mutationWaiters; mutationWaiters = [];
    w.forEach(function (fn) { fn(); });
  }

  // ---------- UI ----------
  function hasUpsellInDom() {
    return !!document.querySelector('.cart-quantity--locked');
  }
  function hostForNote() {
    return document.getElementById('CartDrawer-CartErrors') || document.getElementById('main-cart-items');
  }
  function showMessage(text, isError) {
    if (!text) return;
    var host = hostForNote();
    if (!host) return;
    var old = host.querySelector('.yerb-addon-note');
    if (old) old.remove();
    var el = document.createElement('p');
    el.className = 'yerb-addon-note' + (isError ? ' yerb-addon-note--error' : '');
    el.setAttribute('role', isError ? 'alert' : 'status');
    el.textContent = text;
    if (host.id === 'CartDrawer-CartErrors') host.appendChild(el); else host.insertBefore(el, host.firstChild);
  }
  function flushNote() {
    var text = null;
    try { text = sessionStorage.getItem(NOTE_KEY); if (text) sessionStorage.removeItem(NOTE_KEY); } catch (e) {}
    showMessage(text, false);
  }
  function rerender(note) {
    var cartItems = document.querySelector('cart-items');
    var drawerItems = document.querySelector('cart-drawer-items');
    if (cartItems && typeof cartItems.onCartUpdate === 'function') {
      try { if (note) sessionStorage.setItem(NOTE_KEY, note); } catch (e) {}
      cartItems.onCartUpdate(); // stranka kosiku se znovu nacte, poznamka prezije v sessionStorage
      return;
    }
    if (!drawerItems || typeof drawerItems.onCartUpdate !== 'function') return;
    drawerItems.onCartUpdate(); // replaceWith() vymeni <cart-drawer-items>; pockat na novy uzel
    var tries = 0;
    (function poll() {
      var now = document.querySelector('cart-drawer-items');
      if (now && now !== drawerItems) { showMessage(note, false); return; }
      if (tries++ < 25) setTimeout(poll, 200);
    })();
  }

  // ---------- pozadi ----------
  function run() {
    if (!hasUpsellInDom()) return; // bezny kosik: zadny request navic
    ensureValid(true).then(function (res) {
      if (res.changed) rerender(res.note);
    }).catch(function (e) { if (window.console) console.warn('addon-guard', e); });
  }
  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(run, 800);
  }

  // ---------- pokladna (fail-closed jen kdyz je v kosiku upsell) ----------
  function guardCheckout(form, btn, e) {
    if (!hasUpsellInDom()) return; // bezny kosik: zadny zasah
    if (btn && btn.dataset.yerbGuardPassed) return; // nas vlastni opakovany klik po overeni
    e.preventDefault();
    e.stopImmediatePropagation(); // Globe / jine handlery nesmi navigovat driv, nez je kosik overeny
    if (checkoutRunning) return;
    checkoutRunning = true;
    if (btn) btn.setAttribute('aria-busy', 'true');
    var deadline = new Promise(function (_, rej) { setTimeout(function () { rej(new Error('addon-guard: deadline')); }, CHECKOUT_DEADLINE); });
    var work = waitForMutation().then(function () { return ensureValid(false); }).then(function (res) {
      if (!res.ok) throw new Error('addon-guard: kosik se nepodarilo srovnat');
      if (btn && btn.disabled) return; // mezitim odskrtnute podminky apod.
      if (btn && btn.dataset.globeCheckout) {
        // Globe naviguje sama (/checkout + prefill vydejniho mista); jen ji pustit dal
        btn.dataset.yerbGuardPassed = '1';
        setTimeout(function () { delete btn.dataset.yerbGuardPassed; }, 1500);
        btn.click();
        return;
      }
      // Bez Globe: stary formular nese pozicni updates[] a po opravach (i z pozadi) by mohl mnozstvi
      // prepsat, proto primo do pokladny. Poznamku ke kosiku uklada Dawn pres /cart/update.js.
      window.location.assign(ROOT + 'checkout');
    });
    Promise.race([work, deadline]).catch(function (err) {
      if (window.console) console.warn('addon-guard checkout', err);
      showMessage('Zvýhodněný doplněk jde koupit jen k Yerbu v košíku. Přidej Yerb, nebo doplněk odeber a zkus to znovu.', true);
    }).then(function () {
      checkoutRunning = false;
      if (btn) btn.removeAttribute('aria-busy');
    });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('button[name="checkout"], input[name="checkout"]');
    if (!btn) return;
    guardCheckout(btn.form || btn.closest('form'), btn, e); // Globe klon nema form
  }, true);
  document.addEventListener('submit', function (e) {
    var form = e.target;
    var sub = e.submitter;
    if (!form || !sub || sub.name !== 'checkout') return;
    guardCheckout(form, sub, e);
  }, true);

  // ---------- udalosti ----------
  function onCartEvent() { mutationSettled(); schedule(); }
  document.addEventListener('cart:updated', onCartEvent);
  document.addEventListener('cart-drawer:open', schedule);
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, onCartEvent);
  }
  // zacatek Dawn mutace: klik na odstranit / zmena mnozstvi v kosiku
  document.addEventListener('click', function (e) {
    if (e.target.closest('cart-remove-button, cart-items .quantity-button, cart-drawer-items .quantity-button')) mutationStarted();
  }, true);
  document.addEventListener('change', function (e) {
    if (e.target.closest('cart-items .quantity-input, cart-drawer-items .quantity-input')) mutationStarted();
  }, true);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { flushNote(); schedule(); });
  } else {
    flushNote();
    schedule();
  }
})();
